/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreScheduleDataDto } from '../../models/core-schedule-data-dto';

export interface ProjectAggregatorControllerGetScheduleData$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Optional filter by project manager ID
 */
  projectManagerId?: string;
}

export function projectAggregatorControllerGetScheduleData(http: HttpClient, rootUrl: string, params: ProjectAggregatorControllerGetScheduleData$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreScheduleDataDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectAggregatorControllerGetScheduleData.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('projectManagerId', params.projectManagerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreScheduleDataDto>;
    })
  );
}

projectAggregatorControllerGetScheduleData.PATH = '/o2-core/project-aggregator/{tenant}/schedule';
